import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { Card, CardHeader } from "@mui/material";

function InvoiceTypeBarChart({ xLabels, rData, pData }) {
  return (
    <Card>
      <CardHeader title="Number of Invoice Type" />
      <BarChart
        height={300}
        series={[
          { data: rData, label: "AR", id: "arId" },
          { data: pData, label: "AP", id: "apId" },
        ]}
        xAxis={[{ data: xLabels, scaleType: "band" }]}
      />
    </Card>
  );
}

export default InvoiceTypeBarChart;
